export default __webpack_public_path__ + "static/media/036-shopping bag.f04cc6fd.svg";